import { Select } from 'components/common';
import { SelectProps } from 'components/common/select/Select';
import { useCustomerGroupOptions, useServiceTypesOptions } from 'hooks';
import { useState } from 'react';
import { filterOptions, SERVICE_TYPE_SELECT_ALL } from 'utils';

type SelectVipCustomerGroupsProps = SelectProps & {
  isAll?: boolean;
  isActive?: boolean;
};

const SelectVipCustomerGroups = ({ isAll = false, isActive, ...props }: SelectVipCustomerGroupsProps) => {
  const [keyword, setKeyword] = useState('');
  const { customerGroups, hasMore, handleLoadMore, resetPage, isLoading, isFetching } = useCustomerGroupOptions({
    keyword
  });

  const data = [
    ...(isAll ? [SERVICE_TYPE_SELECT_ALL] : []),
    ...(customerGroups.map((itm) => ({
      label: itm.name,
      value: itm.customerGroupId
    })) || [])
  ];

  const options = filterOptions(data, keyword, 'label');

  const handleChangeKeyword = (val: string) => {
    setKeyword(val);
    resetPage();
  };

  return (
    <Select
      {...props}
      onLoadMore={handleLoadMore}
      loading={isLoading || isFetching}
      showSearch
      filterOption={false}
      onSearch={handleChangeKeyword}
      hasMore={hasMore}
      options={options}
    />
  );
};
export default SelectVipCustomerGroups;
